export const config = {
    apiKey: "AIzaSyBpKGgxjG93CrZjGN74fK0Q8Dgo0bR4Uxg",
    authDomain: "savings-116b3.firebaseapp.com",
    databaseURL: "https://savings-116b3.firebaseio.com",
    projectId: "savings-116b3",
    storageBucket: "savings-116b3.appspot.com",
    messagingSenderId: "379234431303"
};

